import { Component } from '@angular/core';
import { StaticDataService } from '../../services/static-data.service';
import { ConfigurationsService } from '../../services/configurations.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'myt-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: false
})
export class FooterComponent {
  // Click-to-chat deep link for the footer's WhatsApp social icon. Built
  // once at construction time from `environment.waNumber` +
  // `environment.waPrefillMessage` so the pre-filled message and the
  // target phone number both come from per-env config rather than being
  // hard-coded in the template.
  readonly whatsappCtaHref =
    `https://wa.me/${environment.waNumber}?text=${encodeURIComponent(environment.waPrefillMessage)}`;

  constructor(protected staticData:StaticDataService, protected configService: ConfigurationsService) {}
}
